import { useState } from "react";
import { useAlerts } from "@/hooks";
import { getErrorMessage } from "@/utils/getErrorMessage";
import { useDeleteOrgUserMutation } from "../services/roleManagementApi";

export interface DeleteUserModalState {
  open: boolean;
  item_id: string | null;
  item_name: string | null;
  delete_type: "user" | "portfolio" | null;
  org_user_id?: string | null;
}

const CLOSED_STATE: DeleteUserModalState = {
  open: false,
  item_id: null,
  item_name: null,
  delete_type: null,
  org_user_id: null,
};

export const useDeleteUserModal = (orgId: string | undefined) => {
  const { showSuccess, showError } = useAlerts();
  const [deleteOrgUser] = useDeleteOrgUserMutation();

  const [deleteModalStatus, setDeleteModalStatus] =
    useState<DeleteUserModalState>(CLOSED_STATE);

  const openDeleteUser = (userId: string, userName: string) => {
    setDeleteModalStatus({
      open: true,
      item_id: userId,
      item_name: userName,
      delete_type: "user",
    });
  };

  const handleDeleteUser = async () => {
    if (!deleteModalStatus.item_id || !orgId) return;
    try {
      await deleteOrgUser({
        orgId,
        orgUserId: deleteModalStatus.item_id,
      }).unwrap();
      showSuccess("User successfully deleted.");
    } catch (err) {
      showError(`Failed to delete user: ${getErrorMessage(err)}`);
    } finally {
      setDeleteModalStatus(CLOSED_STATE);
    }
  };

  const closeModal = () => setDeleteModalStatus((s) => ({ ...s, open: false }));

  return {
    deleteModalStatus,
    setDeleteModalStatus,
    openDeleteUser,
    handleDeleteUser,
    closeModal,
  };
};
